import { render, staticRenderFns } from "./grossing-touch-incidents-sidepanel.vue?vue&type=template&id=7277ffac&"
import script from "./grossing-touch-incidents-sidepanel.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-incidents-sidepanel.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports